import React from 'react';

import { CustomRowTableCellProps, SelectableOptions } from '@amzn/imdb-shared-meridian-components/components/DataTable';
import Link from '@amzn/meridian/link';

import { ListDetails, PredefinedListDetails } from '../../../../../listoramaAdmin-api/generated-src/api';
import { getListLink } from '../../../../../utils/url';
import { ListDataTable } from '../../../../components/ListDataTable/ListDataTable';
import { HEADERS_CONFIG } from './TableHeadersConfig';

export enum ListType {
    LIST = 'LIST',
    PREDEFINED = 'PREDEFINED'
}

export type ColumnId =
    | 'listId'
    | 'name'
    | 'size'
    | 'state'
    | 'publik'
    | 'listClass'
    | 'listType'
    | 'modified'
    | 'created'
    | 'flags';

export type SelectedLists = { [listId: string]: boolean };

interface ListsDataTableProps {
    lists: ListDetails[] | PredefinedListDetails[];
    listType: ListType;
    selectableOptions?: SelectableOptions;
}

export const LIST_FLAGS_DELIMITER = ', ';

export const TEST_ID = {
    LIST_LINK: 'listLink'
};

export const DEFAULT_LISTS_PER_PAGE = 100;

export const UserListsDataTable: React.FC<ListsDataTableProps> = (props: ListsDataTableProps) => {
    const { lists, listType, selectableOptions } = props;

    return (
        <ListDataTable
            headers={HEADERS_CONFIG[listType]}
            rows={lists.map((list) => {
                return listType === ListType.LIST ? { ...list, flags: list.flags.join(LIST_FLAGS_DELIMITER) } : list;
            })}
            itemsPerPage={DEFAULT_LISTS_PER_PAGE}
            showPaginationOptions={listType === ListType.LIST}
            customRowTableCell={CustomRowTableCell}
            emptyTableText={'User has no lists.'}
            selectableOptions={selectableOptions}
        />
    );
};

const CustomRowTableCell: React.VFC<CustomRowTableCellProps<string>> = (props) => {
    const { row, headerId } = props;
    switch (headerId) {
        case 'listId':
            return <LinkTableCellContent listId={row.listId} text={row.listId} />;
        case 'listClass':
            return row.listClass !== 'LIST' ? (
                <LinkTableCellContent listId={row.listId} text={row.listClass} />
            ) : (
                <DefaultTableCellContent data={row[headerId]} />
            );
        case 'publik':
            return <DefaultTableCellContent data={row.publik ? 'Public' : 'Private'} />;
        default:
            return <DefaultTableCellContent data={row[headerId]} />;
    }
};

const LinkTableCellContent = ({ listId, text }) => {
    return (
        <Link href={getListLink(listId)} data-testid={`${TEST_ID.LIST_LINK}_${listId}`}>
            {text}
        </Link>
    );
};

const DefaultTableCellContent = ({ data }) => <>{data}</>;
